export const state = () => ({
  urlFile: 'https://cdn.mege.com.br/',
})
